import {FC} from 'react';
import {
  getPPIOfferDocuments,
  useCountry,
  useLoanAccountPPIV2,
} from '@resurs-internal/rb-app-api';
import {useTranslate} from 'hooks';
import {useAlertDialog} from 'components';
import {usePPIAnytimeDialog} from '../../../hooks/useDialog/usePPIAnytimeDIalog';
import {PPIDialog} from '../ppi/PPIDialog';

export const PPIAnytimeDialog: FC = () => {
  const country = useCountry();
  const translate = useTranslate();
  const dialog = usePPIAnytimeDialog();
  const accountId = dialog.state?.id;
  const ppi = useLoanAccountPPIV2(accountId);
  const ppiData = ppi.query.data;
  const alert = useAlertDialog();

  const onSubmit = async () => {
    try {
      await ppi.apply.mutateAsync();
      dialog.onClose();
      alert.success({
        title: translate('dialogs.ppi.success.title'),
        subtitle: translate('dialogs.ppi.success.subtitle'),
      });
    } catch (error) {
      dialog.onClose();
      alert.error({
        title: translate('dialogs.ppi.error.title'),
        subtitle: translate('dialogs.ppi.error.subtitle'),
      });
    }
  };

  const documents = getPPIOfferDocuments(country.code);

  const premium = country.formatAmount(ppiData?.insurancePremium);
  const premiumMin = country.formatAmount(ppiData?.minimumFee);
  const premiumMax = country.formatAmount(ppiData?.maximumFee);
  const percentage = `${ppiData?.percentage}%`;
  const countryLower = country.code.toLowerCase();

  return (
    <PPIDialog
      open={dialog.open}
      onClose={dialog.onClose}
      onSubmit={onSubmit}
      submitText={translate('dialogs.ppi.action.apply.text')}
      subtitle={translate(`${countryLower}.ppi.subtitle`, {
        percentage: percentage,
        premium: premium,
        min: premiumMin,
        max: premiumMax,
      })}
      documents={documents}
    />
  );
};
